<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-cogs"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $tc('pallet_missing', 99) }}
        </div>
      </template>
      <v-row class="mx-0">
        <v-col cols="12">
          <v-text-field
            v-model="palletNumber"
            :label="$tc('pallet_number', 99)"
          />
          <v-btn
            :loading="updating"
            :disabled="updating || !palletNumber"
            color="secondary"
            class="ml-auto mt-5"
            @click="updateTracking()"
          >
            Opdater tracking på pakker
          </v-btn>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import { SUPPORT, URL_PREFIX } from '../../../../utils/constants'

  export default {
    data () {
      return {
        crudl: {
          C: SUPPORT.val,
          R: SUPPORT.val,
          U: SUPPORT.val,
          D: SUPPORT.val,
          L: SUPPORT.val,
        },
        palletNumber: '',
        updating: false,

      }
    },
    computed: {

    },
    mounted: function () {
    },
    methods: {
      updateTracking: function () {
        this.updating = true
        this.$post(`/pallets/${this.palletNumber}/missing`).then(({ data }) => {
        })
          .then((r) => {
            if (r?.data?.shipments) { this.$toast(`Tracking event tilføjet til ${r.data.shipments.length} forsendelser`) }
          })
          .catch((r) => {
            if (r?.response?.data?.message) { this.$toast(r?.response?.data?.message, { color: 'red' }) } else { this.$toast('Fejl ved opdatering af tracking', { color: 'red' }) }
          })
          .finally(() => {
            this.updating = false
          })
      },

    },
  }
</script>
